import { render, staticRenderFns } from "./FileAttachementItems.vue?vue&type=template&id=76af7e01&scoped=true&"
import script from "./FileAttachementItems.vue?vue&type=script&lang=js&"
export * from "./FileAttachementItems.vue?vue&type=script&lang=js&"
import style0 from "./FileAttachementItems.vue?vue&type=style&index=0&id=76af7e01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af7e01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76af7e01')) {
      api.createRecord('76af7e01', component.options)
    } else {
      api.reload('76af7e01', component.options)
    }
    module.hot.accept("./FileAttachementItems.vue?vue&type=template&id=76af7e01&scoped=true&", function () {
      api.rerender('76af7e01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Waste/fileModal/FileAttachementItems.vue"
export default component.exports